export default "__VITE_ASSET__mQ53G52m__"